import Swal from 'sweetalert2';

export function confirmDialog({
  title = 'Are you sure?',
  text = 'This action cannot be undone.',
  confirmButtonText = 'Yes, do it!',
  cancelButtonText = 'Cancel'
} = {}) {
  return Swal.fire({
    title: title,
    text: text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#DD6B55',
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText
  }).then((result) => result.isConfirmed);
}

export function successDialog(title = 'Success', text = 'Action completed successfully.') {
  return Swal.fire({ title, text, icon: 'success' }).then(() => undefined);
}

export function errorDialog(title = 'Cancelled', text = 'Action was cancelled.') {
  return Swal.fire({ title, text, icon: 'error' }).then(() => undefined);
}

// ---------------------------------------------------------------------------
// SweetAlert v1 compatibility shim
//
// Many call sites still use the old swal() API:
//   swal("title", "text", "type")
//   swal({ title, text, type, showCancelButton, ... }, callback)
//
// This shim translates both signatures to Swal.fire() so those call sites
// continue to work without modification. Migrate them to Swal.fire() or the
// helpers above over time, then remove this shim.
// ---------------------------------------------------------------------------
function swalShim(titleOrOptions, textOrCallback, type) {
  if (typeof titleOrOptions === 'string') {
    // Positional signature: swal("title", "text", "type")
    return Swal.fire({ title: titleOrOptions, text: textOrCallback, icon: type });
  }

  // Object signature: swal({ ...options }, callback)
  const callback = typeof textOrCallback === 'function' ? textOrCallback : null;
  const { type: legacyType, ...rest } = titleOrOptions;
  return Swal.fire({ ...rest, icon: legacyType }).then((result) => {
    if (callback) callback(result.isConfirmed ? true : null);
    return result;
  });
}

window.swal = swalShim;

// Make available globally for JS ERB templates
window.successDialog = successDialog;
window.errorDialog = errorDialog;
